module.exports = __webpack_public_path__ + "img/pptx_template.f17dd4b7.png";